export default "__VITE_ASSET__C2fB1ZOV__"